<template>
  <section class="marketing-section bg-surface-variant">
    <div class="marketing-section__content">
      <h2 class="text-h4 text-center font-weight-bold mb-10">
        Built for trust
      </h2>

      <v-row>
        <v-col
          v-for="(feature, i) in features"
          :key="i"
          cols="12"
          sm="6"
          md="4"
        >
          <v-card elevation="1" rounded="lg" class="pa-5 h-100">
            <v-icon :color="feature.color" size="36" class="mb-3">
              {{ feature.icon }}
            </v-icon>
            <h3 class="text-subtitle-1 font-weight-bold mb-2">
              {{ feature.title }}
            </h3>
            <p class="text-body-2 text-medium-emphasis mb-0">
              {{ feature.description }}
            </p>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </section>
</template>

<script setup lang="ts">
const features = [
  {
    icon: 'mdi-shield-check',
    color: 'primary',
    title: 'Threshold-funded',
    description: 'Events confirm only when backed by enough real commitments.',
  },
  {
    icon: 'mdi-calendar-lock',
    color: 'secondary',
    title: 'Dates you can count on',
    description:
      'Once fundraising starts, dates and details are locked. Plan your drive with confidence.',
  },
  {
    icon: 'mdi-account-check',
    color: 'tertiary',
    title: 'Organizer accountability',
    description:
      'Listing bonds and reputation tracking keep organizers honest.',
  },
  {
    icon: 'mdi-account-group',
    color: 'secondary',
    title: "See who's going",
    description: 'Check if friends are attending before you commit.',
  },
  {
    icon: 'mdi-currency-usd',
    color: 'primary',
    title: 'Transparent costs',
    description: 'See exactly how funds will be used before you back an event.',
  },
  {
    icon: 'mdi-caravan',
    color: 'tertiary',
    title: 'Built for the road',
    description:
      'Designed for people who drive hundreds of miles to attend, not casual city meetups.',
  },
];
</script>
